import { createFileRoute } from "@tanstack/react-router";
import { PortalFrame } from "@/features/portal-home/PortalFrame";
import { PortalPostsPage } from "@/features/social/PortalPostsPage";

/** Social posts the client approves, inside the portal frame so the client keeps the navigation. */
export const Route = createFileRoute("/portal/social")({ component: PortalPostsRoute });

function PortalPostsRoute() {
  return (
    <PortalFrame>
      <PortalPostsPage />
    </PortalFrame>
  );
}
